import React from 'react';

import { showImagePreviewAction } from 'actions/imagePreview';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { isPdfType, getFileNameFromUrl } from 'constants/helper';

import { FileCardComp } from 'uiToolkit/FileCardComp';

const MediaContainer = styled.div`
  margin-left: 3.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const MediaImage = styled.img`
  // max-width: 100%;
  max-height: 50vh;
  object-fit: contain;
  width: 100%;
  cursor: pointer;
`;

export default function CommentMedia({ media }) {
  const dispatch = useDispatch();

  function showImagePreview(mediaUrl) {
    dispatch(showImagePreviewAction({ images: [mediaUrl] }));
  }
  if (!media?.length) {
    return null;
  }

  return (
    <MediaContainer>
      {media.map((m) => {
        if (isPdfType(m.url)) {
          const fileName = getFileNameFromUrl(m.url);
          return <FileCardComp fileName={fileName} title={fileName} downloadLink={m.url} fullWidth />;
        }

        return <MediaImage src={m.url} onClick={() => showImagePreview(m.url)} />;
      })}
    </MediaContainer>
  );
}
